/**
 * @fileoverview App component.core
 */
'use strict';
// React Import
import React, { Component } from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Main from './Main';
// Library Import
import '../../lib/mobiscroll/themes/material';
import '../../lib/mobiscroll/themes/auto-theme';
import '../../lib/mobiscroll/i18n/ja';
// Util Import
// import * as LogUtil from '../../util/LogUtil';

/**
 * App
 *
 * @class App
 * @extends {Component}
 */
class App extends Component {
  constructor(props) {
    super(props);
    window.console.info('App Class constructor call');
  }

  /**
   * 描画
   *
   * @returns {Object} 画面を構成する要素
   * @memberof App
   */
  render() {
    return (
      <BrowserRouter>
        <Main />
      </BrowserRouter>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/js/component/core/App.jsx